import React from 'react';
import { Reveal } from './Reveal';
import { Label } from './Label';
import { audience } from '../data/site';
export function Audience() {
  return <section id="audience" className="relative w-full border-t border-navy/10 bg-cream-deep/60 py-24 sm:py-32" data-id="element-31" data-mp="3p26x4e147lrq">
      <div className="mx-auto max-w-[720px] px-5 sm:px-8" data-id="element-32" data-mp="6sd4vegzy6sz">
        <Reveal data-id="element-33" data-mp="1uv62gwp17yp">
          <div className="flex items-center gap-3" data-id="element-34" data-mp="1ublstjkm7hi">
            <span className="h-px w-10 bg-copper" data-id="element-35" data-mp="gsdpr4uikuza" />
            <Label data-id="element-36" data-mp="gr2l72t8vj74">Who it is for</Label>
          </div>
          <h2 className="mt-5 font-serif text-4xl italic leading-[1.06] text-navy sm:text-5xl" data-id="element-37" data-mp="bulzef9ipgx7">
            Financial services leaders, not a product demo
          </h2>
          <p className="mt-6 font-sans text-base font-light leading-relaxed text-navy/70 sm:text-lg" data-id="element-38" data-mp="ljm0c47kyme1">
            An independent read: what is feasible, what it costs the organisation, and which sequence
            survives contact with risk, finance and operations.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-39" data-mp="16cydlnukm64f">
          <div className="grain grain-light relative mt-12 overflow-hidden bg-navy px-6 py-10 sm:px-8 sm:py-12" data-id="element-40" data-mp="16dro8zwnhfru">
            <Label tone="copper" data-id="element-41" data-mp="1bcufnhjpjnhc">Built for</Label>
            <ul className="relative mt-8 flex flex-col divide-y divide-cream/12" data-id="element-42" data-mp="1gb5pvtdx0003">
              {audience.map(item => <li key={item} className="py-6 first:pt-0 last:pb-0" data-id="element-43" data-mp="1kd96ewffxus8">
                  <span className="font-serif text-xl italic leading-snug text-cream sm:text-2xl" data-id="element-44" data-mp="1pbu5gsiyi8f3">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}